/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPartVII
 */
export interface ExecRiskPartVII {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartVII
     */
    ack_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartVII
     */
    row_order?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartVII
     */
    sf_plan_transfer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartVII
     */
    sf_plan_transfer_ein?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartVII
     */
    sf_plan_transfer_pn?: string;
}

/**
 * Check if a given object implements the ExecRiskPartVII interface.
 */
export function instanceOfExecRiskPartVII(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskPartVIIFromJSON(json: any): ExecRiskPartVII {
    return ExecRiskPartVIIFromJSONTyped(json, false);
}

export function ExecRiskPartVIIFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPartVII {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ack_id': !exists(json, 'ack_id') ? undefined : json['ack_id'],
        'row_order': !exists(json, 'row_order') ? undefined : json['row_order'],
        'sf_plan_transfer_name': !exists(json, 'sf_plan_transfer_name') ? undefined : json['sf_plan_transfer_name'],
        'sf_plan_transfer_ein': !exists(json, 'sf_plan_transfer_ein') ? undefined : json['sf_plan_transfer_ein'],
        'sf_plan_transfer_pn': !exists(json, 'sf_plan_transfer_pn') ? undefined : json['sf_plan_transfer_pn'],
    };
}

export function ExecRiskPartVIIToJSON(value?: ExecRiskPartVII | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ack_id': value.ack_id,
        'row_order': value.row_order,
        'sf_plan_transfer_name': value.sf_plan_transfer_name,
        'sf_plan_transfer_ein': value.sf_plan_transfer_ein,
        'sf_plan_transfer_pn': value.sf_plan_transfer_pn,
    };
}

